import { useState } from 'react';
import { SegTextarea } from '../../../../../Components/SegUI/SegTextArea/SegTextArea';
import { SegButton } from '../../../../../Components/SegUI/SegButton/SegButton';
import { StepComponentProps } from '../../Siniestros';
import { SiniestroData, useSiniestroStore } from '../../../../../Services/Providers/SiniestroStore';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { GuardarSiniestro } from '../../../../../Services/API/GuardarSiniestro';
import { guardarArchivoSiniestro } from '../../../../../Services/API/GuardarArchivoSiniestro';

const MAX_FILE_SIZE_MB = 2;

export const RoboTotal = ({ setSteps, config }: StepComponentProps) => {
  const { siniestroValues, setSiniestroValues } = useSiniestroStore();
  const { formState, handleSubmit, control, setValue, trigger } = useForm({
    defaultValues: {
      relato: ""
    }
  });

  const [fileBase64, setFileBase64] = useState<{ name: string, base64: string, type: string }>();
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [enviado, setEnviado] = useState<boolean>(false);

  function convertirImagenABase64(e: any) {
    const archivo = e.target.files[0]; // Obtiene el archivo seleccionado

    const lector = new FileReader();

    if (archivo) {
      lector.onloadend = function () {
        const base64String = (lector.result as string).split(',')[1];
        setFileBase64({
          name: archivo.name,
          base64: base64String,
          type: archivo.type.split("/")[0]
        })
      };

      lector.readAsDataURL(archivo);
    }
  }

  const onSubmit: SubmitHandler<any> = async (data) => {
    setIsLoading(true);

    setSiniestroValues({
      tipoSiniestro: "RoboTotal",
      relatoHechos: data.relato,
      denunciaPolicial: fileBase64 ? fileBase64.base64 : null
    });

    try {
      const resp = await GuardarSiniestro({
        ...siniestroValues,
        tipoSiniestro: "RoboTotal",
        relatoHechos: data.relato,
        denunciaPolicial: fileBase64 ? fileBase64.base64 : null
      } as SiniestroData);

      if (resp.caseId) {
        setErrorMessage("");
        if (fileBase64) {
          const base64SizeMB = (fileBase64.base64.length * (3 / 4)) / (1024 * 1024);

          if (base64SizeMB > MAX_FILE_SIZE_MB) {
            setErrorMessage(`El tamaño del archivo excede el límite permitido, pero no te preocupes, podés enviarlo por mail a <a href="mailto:siniestros@segurarse.com.ar">siniestros@segurarse.com.ar</a> y nos encargaremos de recibirlo.`);
            setEnviado(true)
            setIsLoading(false)
            return;
          }

          const resp2 = await guardarArchivoSiniestro(resp.caseId, fileBase64 ? fileBase64.base64 : "", fileBase64?.type);
          if (
            typeof resp2?.data === "string" &&
            resp2.data.trim().startsWith("<!DOCTYPE html")
          ) {
            setErrorMessage(`El tamaño del archivo excede el límite permitido, pero no te preocupes, podés enviarlo por mail a <a href="mailto:siniestros@segurarse.com.ar">siniestros@segurarse.com.ar</a> y nos encargaremos de recibirlo.`);
            return;
          }
          if (resp2.code === "ERR_NETWORK" || resp2.code === "ECONNABORTED") {
            setErrorMessage(`El tamaño del archivo excede el límite permitido, pero no te preocupes, podés enviarlo por mail a <a href="mailto:siniestros@segurarse.com.ar">siniestros@segurarse.com.ar</a> y nos encargaremos de recibirlo.`);
            return;
          }
        }
        setEnviado(true);
      } else {
        setErrorMessage("Ocurrio un error, intentalo otra vez.");
      }
    } catch (error) {
      console.log(error)
    }
    setIsLoading(false);
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="row justify-content-center pt-4 pb-4">
      <div className="col-md-8">

        <div className="alert alert-info mb-4">
          <p>Es imprescindible que efectúes la denuncia policial y nos envíes una copia a <a href="mailto:siniestros@segurarse.com.ar">siniestros@segurarse.com.ar</a></p>
        </div>

        <Controller
          name="relato"
          control={control}
          rules={{ required: "El relato del hecho es obligatorio" }}
          render={({ field, fieldState }) => (
            <>
              <SegTextarea
                label="Relato del hecho"
                placeHolder="Describe lo más detallado posible cómo sucedió el robo"
                width={100}
                className='mb-3'
                onChange={(e) => {
                  field.onChange(e);
                  setValue("relato", e.target.value);
                  trigger("relato");
                }}
                value={field.value}
                name=''
                leyendaError={fieldState?.error?.message}
                borderColor={fieldState?.error ? "var(--bs-form-invalid-border-color)" : ""}
                focusBorderColor={fieldState?.error ? "var(--bs-form-invalid-border-color)" : "#2c7dfd"}
              />
              <span></span>
            </>
          )}
        />

        <div className="mb-3">
          <label className="form-label">Denuncia policial</label>
          <div className="custom-file-input">
            <input
              type="file"
              className="form-control"
              accept="image/*,application/pdf"
              onChange={convertirImagenABase64}
            />
            {fileBase64 && (
              <small className="text-success">
                Archivo seleccionado: {fileBase64.name}
              </small>
            )}
          </div>
        </div>
        {enviado &&
          <div className="alert alert-success" role="alert">
            Denuncia enviada correctamente
          </div>
        }
        {errorMessage && (
          <div
            className="alert alert-danger"
            dangerouslySetInnerHTML={{ __html: errorMessage }}
          />
        )}
        <div className="text-center mt-4">
          <SegButton
            label={isLoading ? "Enviando denuncia" : "Enviar denuncia"}
            type="submit"
            disabled={!formState.isValid || enviado}
            loading={isLoading}
            bgColor={config.origen !== "SEGURARSE" ? config.colors.primary : undefined}
            hoverBgColor={config.origen !== "SEGURARSE" ? config.colors.primary : undefined}
            hoverBorderColor={config.origen !== "SEGURARSE" ? config.colors.accent : undefined}
            hoverOpacity={config.origen !== "SEGURARSE"}
          />
        </div>
      </div>
    </form>
  );
};
